export function isDate(obj: any | Date): obj is Date {
  // see https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
  return obj && Object.prototype.toString.call(obj) === '[object Date]';
}
